export default __webpack_public_path__ + "static/media/404.c3a23569.svg";